<mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
  <mat-tab label="Detail"> <app-organization-detail></app-organization-detail></mat-tab>
  <mat-tab label="Metrics"> <app-organization-metrics></app-organization-metrics></mat-tab>
  <mat-tab label="Users"> <app-organization-users></app-organization-users></mat-tab>
  <mat-tab label="Patient Metrics"> <app-organization-patient-metrics></app-organization-patient-metrics></mat-tab>
  <mat-tab label="DCI Metrics"> <app-organization-dci-metrics></app-organization-dci-metrics></mat-tab>
</mat-tab-group>
